import * as React from 'react'
import { makeStyles, Typography } from '@material-ui/core';
import { oldURLDictionary } from './matchDictionary';
import {  PortalContext } from '@portal/arq-portal-core';


export const EnlacePortalAntiguo = (props:any) => {
  const useStyles = makeStyles(() => ({
    message:{
      fontSize:'12px',
      lineHeight: '14px',
    },
    messagecontainer: {
      display: 'flex',
      backgroundColor: '#e0dfce',
      borderLeft: '5px solid #5b5c43',
      color: '#5b5c43',
      alignItems: 'center',
      padding: '2px',
      '& i': {
        fontSize: '28px', 
        position: 'relative', 
        bottom: 0, 
        right: 0, 
        width: '40px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      '& a': {
        borderBottom:'1px solid #5b5c43',
        '&:hover': {
          opacity: '0.7',
        }
      }

    },
    generalWrapper: {
      padding:'10px 20px'
    }
  }
  )); 
  const classes = useStyles(props);
  let { mostrarEnlacePortalAntiguo } = React.useContext(PortalContext);

  const getPrevioUrl = () =>{
    const current = window.location.hostname.toLowerCase();
    return (oldURLDictionary[current] && oldURLDictionary[current] != "")? 'https://' + oldURLDictionary[current] : ''
  }

  const redirect = () => {
    document.cookie = "PortalNoRedirect=false;Domain=.gco.global;Path=/;Expires=Fri, 31 Dec 9999 23:59:59 GMT";
    setTimeout(()=>{
      const url = getPrevioUrl();
      window.location.href = url;
    }, 250);
  }

  return !mostrarEnlacePortalAntiguo? null: <div className={classes.generalWrapper} style={ props.style? props.style :{backgroundColor: 'transparent'}}>
          <div className={classes.messagecontainer}>
              <i className={`icon-info-fixed`} style={{}}> </i> 
              <Typography variant="body2" className={classes.message}>
                  Accede al nuevo <a href="#" onClick={redirect}> portal Occident</a>
              </Typography>
          </div>
         </div>
  }
